import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Stack,
  Paper,
  Grid,
  Fade,
} from '@mui/material'
import ServerUtils from '../utils/server'
import toast from 'react-hot-toast'
import localization from '../utils/localization'

function ModalDashboard(props) {
  const [stats, setStats] = useState({
    userCount: 0,
    yesterdayUserCount: 0,
    contentCount: 0,
    yesterdayContentCount: 0,
  })

  useEffect(() => {
    if (!props.open) return
    ServerUtils.getStatistics().then(async (resp) => {
      if (!resp.ok) {
        try {
          let respJson = await resp.json()
          if (respJson.errno !== 0) {
            toast.error(ServerUtils.handleError(respJson))
            return
          }
        } catch (e) { }
        toast.error(localization.strings.networkErr)
        return
      }
      let respJson = await resp.json()
      if (respJson.errno !== 0) {
        toast.error(ServerUtils.handleError(respJson))
        return
      }
      setStats({
        userCount: respJson.data.total_user_num,
        yesterdayUserCount: respJson.data.yesterday_user_num,
        contentCount: respJson.data.total_content_num,
        yesterdayContentCount: respJson.data.yesterday_content_num,
      })
    })
  }, [props.open])

  const statItems = [
    {
      label: localization.strings.userTotal,
      value: stats.userCount,
      icon: 'icon-friends',
      color: '#6366F1',
      bg: 'rgba(99, 102, 241, 0.1)',
    },
    {
      label: localization.strings.userYesterday,
      value: stats.yesterdayUserCount,
      icon: 'icon-add',
      color: '#10B981',
      bg: 'rgba(16, 185, 129, 0.1)',
    },
    {
      label: localization.strings.contentTotal,
      value: stats.contentCount,
      icon: 'icon-all',
      color: '#F59E0B',
      bg: 'rgba(245, 158, 11, 0.1)',
    },
    {
      label: localization.strings.contentYesterday,
      value: stats.yesterdayContentCount,
      icon: 'icon-lock',
      color: '#EF4444',
      bg: 'rgba(239, 68, 68, 0.1)',
    },
  ]

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '28px',
          p: 1,
          backgroundColor: '#F8FAFC',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          textAlign: 'center',
          pt: 4,
          pb: 1,
          color: '#1E293B',
        }}
      >
        Dashboard
      </DialogTitle>
      <DialogContent sx={{ px: 3, pb: 4 }}>
        <Fade in={props.open} timeout={500}>
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              {statItems.map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      borderRadius: '24px',
                      border: '1px solid rgba(0,0,0,0.04)',
                      backgroundColor: '#fff',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: `0 12px 24px ${item.bg}`,
                        borderColor: item.color,
                      },
                    }}
                  >
                    <Stack spacing={2}>
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: '14px',
                          backgroundColor: item.bg,
                          color: item.color,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <i className={`iconfont ${item.icon}`} style={{ fontSize: '1.5rem' }}></i>
                      </Box>
                      <Box>
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: 800,
                            color: '#1E293B',
                            fontFamily: "'Poppins', sans-serif",
                            mb: 0.5,
                          }}
                        >
                          {item.value}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#64748B',
                            fontWeight: 600,
                            fontSize: '0.85rem',
                          }}
                        >
                          {item.label}
                        </Typography>
                      </Box>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  )
}

export default ModalDashboard
